import { ReactNode } from "react";
import { Link, useLocation } from "react-router-dom";
import {
  ListItemIcon,
  ListItemText,
  ListItem,
  alpha,
  List,
  Chip,
} from "@mui/material";
import { useConfigPageContext } from "src/Contexts/configPagesContext/configPagesContext";
import { useResetInputs } from "src/Contexts/hooks/useResetInputs";

type Props = {
  title: string;
  to: string;
  icon?: ReactNode;
  isProducer?: boolean;
  to2?: string;
  isNew?: boolean;
  isFuture?: boolean;
  isDisabled?: boolean;
};

export const AsideMenuLeft = ({ title, to, icon, isProducer, to2, isNew, isFuture, isDisabled }: Props) => {
  const { currentPage, setCurrentPage } = useConfigPageContext();
  const { pathname } = useLocation();
  const { resetInputs } = useResetInputs();

  const isActive = pathname === to || pathname === to2 || false;

  const resetCurrentPage = () => {
    if (currentPage !== 1) setCurrentPage(1);
    resetInputs();
  };

  return (
    <>
      {!isProducer && (
        <Link
          style={{
            textDecoration: "none",
            pointerEvents: isDisabled ? "none" : "auto",
          }}
          to={to}
        >
          <List disablePadding component="div" sx={{ padding: "1px 0" }}>
            <ListItem
              button
              disabled={isDisabled}
              sx={{
                background: isActive ? alpha("#3980f5", 0.2) : "",
                borderRight: isActive ? `4px solid #3980f5` : "",
                color: isDisabled ? alpha("#3b3b3b", 0.5) : "#3b3b3b",
                marginRight: "-15px",
                padding: "4px 12px",
                "&:hover": {
                  backgroundColor: isDisabled ? "transparent" : alpha("#3980f5", 0.2),
                },
                transition: ".1s",
              }}
            >
              {icon ? (
                <ListItemIcon
                  sx={{
                    color: isDisabled ? alpha("#3b3b3b", 0.5) : "#3b3b3b",
                    marginRight: "-20px",
                    marginLeft: "4px",
                    "& svg": { fontSize: "20px" },
                  }}
                >
                  {icon}
                </ListItemIcon>
              ) : (
                <ListItemIcon sx={{ color: "#3b3b3b", marginRight: "-15px", }} />
              )}

              <ListItemText
                disableTypography
                primary={title}
                sx={{
                  color: isDisabled ? alpha("#3b3b3b", 0.5) : "#3b3b3b",
                  fontSize: "15px",
                  marginLeft: "-4px",
                }}
                onClick={resetCurrentPage}
              />

              {isNew && (
                <Chip
                  label="New"
                  color="primary"
                  size="small"
                  sx={{ marginLeft: "20px", fontSize: "9px", p: "0px" }}
                />
              )}
              {isFuture && (
                <Chip
                  label="Breve"
                  color="default"
                  size="small"
                  sx={{ marginLeft: "10px", fontSize: "10px", p: "0px" }}
                />
              )}
            </ListItem>
          </List>
        </Link>
      )}
    </>
  );
};
